import { Component, HostListener, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-fs-splitter',
  templateUrl: './filesystem-splitter.component.html',
  styleUrls: ['./filesystem-splitter.component.scss']
})
export class FilesystemSplitterComponent {
  @Input() leftContent: TemplateRef<any>;
  @Input() rightContent: TemplateRef<any>;

  leftPaneWidth = 240; // Larghezza iniziale del pannello sinistro
  isResizing = false;
  initialX = 0;

  startResizing(event: MouseEvent) {
    this.isResizing = true;
    this.initialX = event.clientX;
  }

  @HostListener('document:mousemove', ['$event'])
  onResize(event: MouseEvent) {
    if (this.isResizing) {
      const offset = this.initialX - event.clientX;
      this.leftPaneWidth -= offset;
      this.initialX = event.clientX;
    }
  }

  @HostListener('document:mouseup')
  stopResizing() {
    this.isResizing = false;
  }
}
